module.exports = __webpack_public_path__ + "img/bottom-icon4.94ca21ff.png";